<template>
    <b-modal id="vendor_other" ref="vendor_other" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div v-if="mode === 'status'">
                Update Status for<br>
                <div class="text-primary"> {{vendor.data.attributes.name}}</div>
            </div>

            <div v-if="mode === 'comment' || edit">
                {{ !edit ? 'Add' : 'Edit' }} comment for<br>
                <div class="text-primary"> {{vendor.data.attributes.name}}</div>
            </div>
        </template>

        <div v-if="mode === 'status'" class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the vendor!
            </p>
        </div>

        <div v-if="mode === 'comment' || edit" class="d-flex flex-row mb-4">
            <span class="iconsminds-speach-bubbles mr-3 menu-icon-style"/>

            <p class="my-auto">You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the vendor!
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError" class="mb-2">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row v-if="mode === 'status'">
                <b-colxx xxs="12" class="mt-1 mb-2">
                    <span>Do you want to change the status? <sup><code>*</code></sup></span>
                </b-colxx>

                <b-colxx xxs="2" class="mb-2">
                    <toggle-button v-model="form.active" @input="'active' in errors ? (delete errors.active) : ''"
                                   :labels="{checked: 'YES', unchecked: 'NO'}" :height="28" :width="58"
                                   :color="{checked: '#28A745', unchecked: '#8F8F8F'}"/>
                </b-colxx>

                <b-colxx xxs="10" class="mb-2">
                    <h6>
                        <b-badge :variant="'outline-' + (form.active ? 'success' : 'danger')">
                            The Vendor will be {{ form.active ? 'ACTIVE' : 'INACTIVE' }} after submission!
                        </b-badge>
                    </h6>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Comment" class="has-float-label">
                        <template v-slot:label>
                            <span>Comment <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.comment" rows="6"
                                         :class="{'border-danger': 'comment' in errors}"
                                         @input="'comment' in errors ? delete errors.comment : ''" placeholder="Comment"/>

                        <b-form-invalid-feedback :state="!'comment' in errors"
                                                 v-text="'comment' in errors ? errors.comment[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('vendor_other')" v-text="'Cancel'"/>

            <template v-if="mode === 'status' && currentStatus === form.active">
                <b-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')" disabled v-text="'Submit'"/>
            </template>

            <template v-else>
                <state-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')" :click="submitVendorOther">Submit</state-button>
            </template>

            <state-button variant="primary" v-if="edit" :click="updateVendorComment">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import Switches from 'vue-switches';
    import StateButton from "../../../../components/Common/StateButton";

    export default {
        name: "VendorOtherModal",

        components: {
            Switches,
            StateButton
        },

        data() {
            return {
                validationError: null
            }
        },

        props: [
            'vendor', 'mode', 'edit', 'currentStatus'
        ],

        computed: {
            ...mapGetters({
                form: 'getVendorOtherForm',
                errors: 'getVendorErrors',
            }),

            statusComment() {
                if (this.form.comment) {
                    if (this.form.active) {
                        return '[ACTIVATED] ' + this.form.comment;
                    } else {
                        return '[DEACTIVATED] ' + this.form.comment;
                    }
                }

                return '';
            }
        },

        methods: {
            submitVendorOther() {
                return new Promise((success, fail) => {
                    if (this.mode === 'status') this.$store.dispatch('submitVendorStatus', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                let newStatus = response.data.data.attributes.status.toLowerCase() === 'active';

                                this.$emit('updated', newStatus);

                                this.resetModal();

                                this.$notify('success filled', 'Success!', 'Status updated!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_other');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                    else if (this.mode === 'comment') this.$store.dispatch('submitVendorComment', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetModal();

                                this.$notify('success filled', 'Success!', 'New comment added!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_other');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                });
            },

            updateVendorComment() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateVendorComment', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetModal();

                                this.$notify('success filled', 'Success!', 'Comment Updated!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_other');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                });
            },

            resetModal() {
                this.$emit('close');
                this.$store.commit('setVendorOtherForm');
                this.validationError = null;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
